import { FloatingFormItem } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import {
  GenerateAccountPayableFormValues,
  GenerateAccountPayablePeriodDate,
  GenerateAccountsPayableIssueDate,
} from '@/core/domain/financial/ForecastPayable/ForecastPayable.types';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  ModalProps,
  Radio,
  Row,
  Typography,
} from 'antd';
import moment from 'moment';

import React from 'react';

interface Props extends Omit<ModalProps, 'onOk'> {
  isLoading?: boolean;
  onCallback: (values: GenerateAccountPayableFormValues) => void;
}

const GenerateAccountPayableModal: React.FC<Props> = ({
  onCallback,
  onCancel,
  open,
  isLoading,
}) => {
  const [form] = Form.useForm<GenerateAccountPayableFormValues>();

  return (
    <Modal
      width={500}
      open={open}
      onCancel={onCancel}
      title="Geração de Contas a Pagar"
      footer={
        <SpaceForButton justifyContent="flex-end">
          <Button type="primary" ghost onClick={onCancel}>
            Cancelar
          </Button>

          <Button
            type="primary"
            loading={isLoading}
            onClick={() => onCallback(form.getFieldsValue())}
          >
            Gerar Contas a Pagar
          </Button>
        </SpaceForButton>
      }
      destroyOnClose
    >
      <Form form={form}>
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <Typography.Title level={5}>Tipo de geração</Typography.Title>

            <Form.Item
              name="periodDate"
              noStyle
              initialValue={GenerateAccountPayablePeriodDate.monthly}
            >
              <Radio.Group optionType="button" buttonStyle="solid" size="large">
                <Radio value={GenerateAccountPayablePeriodDate.monthly}>
                  Por mês
                </Radio>
                <Radio value={GenerateAccountPayablePeriodDate.weekly}>
                  Por semana
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col span={12}>
            <FloatingFormItem
              name="initialDate"
              label="Mês/ano inicial"
              initialValue={moment()}
              rules={[{ required: true }]}
            >
              <DatePicker
                style={{ width: '100%' }}
                format="MM/YYYY"
                picker="month"
                placeholder=""
              />
            </FloatingFormItem>
          </Col>

          <Col span={12}>
            <FloatingFormItem
              name="finalDate"
              label="Mês/ano final"
              initialValue={moment()}
              rules={[{ required: true }]}
            >
              <DatePicker
                style={{ width: '100%' }}
                format="MM/YYYY"
                picker="month"
                placeholder=""
              />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <Typography.Title level={5}>
              Data de emissão igual a:
            </Typography.Title>

            <Form.Item
              name="issueDate"
              noStyle
              initialValue={GenerateAccountsPayableIssueDate.currentDate}
            >
              <Radio.Group optionType="button" buttonStyle="solid" size="large">
                <Radio value={GenerateAccountsPayableIssueDate.currentDate}>
                  Data atual
                </Radio>
                <Radio value={GenerateAccountsPayableIssueDate.dueDate}>
                  Data de vencimento
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default GenerateAccountPayableModal;
